/*
 * @Author: zhangsheng
 * @Date: 2023-08-21 09:59:12
 * @LastEditors: zhangsheng
 * @LastEditTime: 2023-08-21 11:05:33
 * @FilePath: \demo\src\common\components\lozyLoad\index.tsx
 * @Description:
 *
 * Copyright (c) 2023 by zhangsheng , All Rights Reserved.
 */
import React from "react";
import Loading from "@c/components/Loading";

export default function lazyLoad(Comp: any) {
  return (
    <React.Suspense fallback={<Loading />}>
      <Comp />
    </React.Suspense>
  );
}
